import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../../utils/intercepter/axiosConfig';
import QuittanceTrConservation from '../quittance/QuittanceTrConservation';

const ShowHypo = () => {

    const {id_hypotheque} = useParams();
    const [w_id, setWId] = useState('');

    const navigate = useNavigate();

    const [hypotheque, setHypotheque] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // TR Conservation
    const [montantTrConservationHypo, setMontantTrConservationHypo] = useState(0);
    const [num_tr_code_conservation_hypo, setNumTrConservationHypo] = useState(0);
    const [etat_tr_conservation_hypo, setEtatTrConservationHypo] = useState(0);
    const [id_tr_quittance_tr_conservation_hypo, setIdTrQuittanceHypo] = useState(0);

    const [statusActeHypothque, setStatusActeHypotheque] = useState(false);


      const [num_depot_hypo, setNumDepotHypo] = useState(null);
      const [date_depot_hypo, setDateDepotHypo] = useState(null);


    const checkStatusActedeHypotheque = async () => {
       try {
          const response = await api.post('/auth/checkStatusActeDeHypotheque',{
             "hypotheque_id":id_hypotheque
          });

          if(response.data.status){
            setStatusActeHypotheque(true)
          }
          else{
            setStatusActeHypotheque(false)
          }
        } catch (error) {
          console.log("Erreur Connexion")
        }
    }

    const fetchTrConservationHypoByWId = async () => {
      try {
        const response = await api.post("/auth/getTrConservationHypoByWId",{
          w_id : w_id
        })

        if(response.data.status){
          setMontantTrConservationHypo(response.data.response.montant);
          setNumTrConservationHypo(response.data.response.num_tr);
          setEtatTrConservationHypo(response.data.response.etat);
          setIdTrQuittanceHypo(response.data.response.id);
        }
        else{
          console.log("Aucun TR Conservation")
        }
      } catch (error) {
        console.log("Erreur connexion")
      }
    }
    
    const fetchHyothequeById = async () => {

        setLoading(true);
        try{
            const response = await api.post('/auth/getInfoHypotheques',{
                id_hypotheque: id_hypotheque
            });

            if(response.data.status){
                setHypotheque(response.data.response);
                setWId(response.data.response.w_id)
                setNumDepotHypo(response.data.response.num_depot);
                setDateDepotHypo(response.data.response.date_depot);
            }
            else{
                setError("Aucune hypothéque trouvée");
            }
        }catch(error){
            console.log(error)
        }finally {
                    setLoading(false);
                }
    }

    useEffect(() => {
        if(id_hypotheque){
            fetchHyothequeById();
            checkStatusActedeHypotheque();
        }
    },[id_hypotheque])

    useEffect(() => {
      if(w_id){
        fetchTrConservationHypoByWId();
      }
    }, [w_id])

    if(loading){
        return (
            <div className='container'>
                <div className="alert alert-danger" role="alert">
                Chargement des données...
            </div>
            </div>
        )
    }

    if (error) {
        return (
            <div className='container'>
                <div className="alert alert-danger" role="alert">
                {error}
            </div>
            </div>
        );
    }

    if (!hypotheque) {
        return (
            <div className='container'>
                <div className="alert alert-danger" role="alert">
                Aucune donnée disponible.
            </div>
            </div>
        );
    }

        const retour = () => {
        navigate(-1);
    }



  return (
    <div className='main-container'>
        <div className='container'>
            <div className='row'>
                <div className='col-12 col-md-4 mb-4'>
                    <div className='card mt-4'>
                        <div className='card-header d-flex justify-content-between align-items-center'>
                            <span>Les informations de la hypothéque</span>
                            <button onClick={retour} className='btn btn-secondary btn-sm'>
                                Retour
                            </button>
                        </div>

                        <div className='card-body'>

                            <table className="table table-bordered table-striped">
              <tbody>
                <tr>
                  <td className="text-start">N° demande</td>
                  <td className="text-end">{hypotheque.num_demande}</td>
                </tr>
                <tr>
                  <td className="text-start">Banque</td>
                  <td className="text-end">{hypotheque.libelle}</td>
                </tr>
                <tr>
                  <td className="text-start">Rang hypo</td>
                  <td className="text-end">{hypotheque.rang_hypo}</td>
                </tr>
                {/* <tr>
                  <td className="text-start">NNI Acheteur</td>
                  <td className="text-end">{vente.nni_acheteur}</td>
                </tr>
                <tr>
                  <td className="text-start">Nom Acheteur</td>
                  <td className="text-end">{vente.nom_acheteur}</td>
                </tr> */}
                <tr>
                  <td className="text-start">TF</td>
                  <td className="text-end">
                    <span className="badge bg-warning text-white">
                      {hypotheque.TFs}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="text-start">Montant</td>
                  <td className="text-end">
                    <span className="fw-bold text-success">
                      
                      {hypotheque.montant.toLocaleString('fr-FR', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })} MRU

                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="text-start">Date</td>
                  <td className="text-end">{hypotheque.date_hypo}</td>
                </tr>

                {num_depot_hypo ? (<tr>
                  <td className="text-start">Num de depot</td>
                  <td className="text-end">{num_depot_hypo}</td>
                </tr>) : ('')}

                {date_depot_hypo ? (<tr>
                  <td className="text-start">Date de depot</td>
                  <td className="text-end">{date_depot_hypo}</td>
                </tr>) : ('')}

                {/* <tr>
                  <td className="text-start">État</td>
                  <td className="text-end">
                    {vente.Etat === 1 ? (
                      <span className="badge bg-success">En cours de vente</span>
                    ) : (
                      <span className="badge bg-danger">Non Validée</span>
                    )}
                  </td>
                </tr> */}
              </tbody>
            </table>

            <span className='text-start'>TR Conservation</span>
            <table className='table table-bordered table-striped'>
              <tbody>
                <tr>
                  <td className='text-start'> Montant</td>
                  <td>
                    
                    {montantTrConservationHypo.toLocaleString('fr-FR', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })} MRU

                  </td>
                </tr>
                <tr>
                  <td className='text-start'>Code</td>
                  <td>
                    {num_tr_code_conservation_hypo.toLocaleString()}
                  </td>
                </tr>
                <tr>
                  <td className='text-start'>
                    Opérations
                  </td>
                  <td className='d-flex align-items-center grap-2'>
                    <button className='btn btn-warning btn-sm d-flex align-items-center'>
                      Recevoir
                    </button> 
                    {etat_tr_conservation_hypo === 0 ?(<button className='btn btn-success btn-sm d-flex align-items-center'
                    
                    onClick={() => navigate(`/hypotheque/paiements/${hypotheque.w_id}`,{
                                                             state: {
                                                              id_hypotheque: id_hypotheque
                                                             } 
                                                            })}
                    
                    >
                      Payé
                    </button>):('')}
                    
                  </td>
                </tr>
              </tbody>
            </table>

            {etat_tr_conservation_hypo === 1 ? (
                      <QuittanceTrConservation
                      id_quittance_tr_conservation={id_tr_quittance_tr_conservation_hypo}
                      w_id={w_id}
                      />
                    ):('')}

                    {etat_tr_conservation_hypo === 1 && statusActeHypothque === false ? (

                    <div className='row'>
                      <div className='col-12'>
                        <button className='btn btn-secondary btn-sm w-100'
                        onClick={() => {
                          navigate(`/hypotheque/acte-hypotheque/${id_hypotheque}`)
                        }}
                        >
                          Initier Acte de Hypotheque
                        </button>
                      </div>
                    </div>
                    ): null}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ShowHypo
